import { connect } from 'react-redux';

import ExpireSubModal from './ExpireSubModal';
import { expireSimoSubscription, findSimoSub } from 'actions/simoSubs';
import { getIsAdmin, getIncludedInGroups, getLoggedInUser } from 'reducers';
import { fetchSimoExpiryOptions } from 'api';

const mapStateToProps = (state) => ({
  isAdmin: getIsAdmin(state),
  isReseller: getIncludedInGroups(state, ['RESELLER']),
  loggedInUser: getLoggedInUser(state),
  isSimo: true,
  showBypass: false,
  showProration: false,
  showPin: false,
  fetchExpiryOptions: fetchSimoExpiryOptions,
});

const mapDispatchToProps = {
  expireSub: expireSimoSubscription,
  findSub: findSimoSub,
};

const ExpireSimoSubModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExpireSubModal);

export default ExpireSimoSubModal;
